/**
 * @generated SignedSource<<a8845090ab07fe2eaa2ddaaa7c7b2bb3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { Url } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceDOIFragment$data = {
  readonly bibtex: string | null | undefined;
  readonly doi: {
    readonly full: string;
    readonly short: string | null | undefined;
    readonly url: Url;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "WorkspaceDOIFragment";
};
export type WorkspaceDOIFragment$key = {
  readonly " $data"?: WorkspaceDOIFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceDOIFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceDOIFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bibtex",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DOI",
      "kind": "LinkedField",
      "name": "doi",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "full",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "short",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WorkspaceVersion",
  "abstractKey": null
};

(node as any).hash = "325833dd73f5b8918eadf752da341632";

export default node;
